/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Sea_Lemur_HurlInputs */

const fr_extra_sea_lemur_hurl = /** @type {(inputs: Extra_Sea_Lemur_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook Page`)
};

/**

* @param {Extra_Sea_Lemur_HurlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_sea_lemur_hurl = /** @type {((inputs?: Extra_Sea_Lemur_HurlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Sea_Lemur_HurlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_sea_lemur_hurl(inputs)
});